import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import options from './revenue-options';

@Injectable({ providedIn: 'root' })
export class RevenueDisplayService implements DataFilterDisplayService {
  constructor(private readonly translateService: TranslateService) {}

  getDisplay(values: string[]): Observable<string> {
    return of(
      `<b>${values
        .map((v) => {
          const option = options.find((opt) => opt.value === v);
          return this.translateService.instant(option?.label);
        })
        .join(', ')}</b>`,
    );
  }
}
